var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreenFilledBordered({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#299B69",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 64.75C21.6985 64.75 9.25 52.3015 9.25 37C9.25 21.6985 21.6985 9.25 37 9.25C52.3015 9.25 64.75 21.6985 64.75 37C64.75 52.3015 52.3015 64.75 37 64.75Z",
    fill: "#20BE79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 10C51.8875 10 64 22.1125 64 37C64 51.8875 51.8875 64 37 64C22.1125 64 10 51.8875 10 37C10 22.1125 22.1125 10 37 10ZM37 8.5C21.2605 8.5 8.5 21.2605 8.5 37C8.5 52.7395 21.2605 65.5 37 65.5C52.7395 65.5 65.5 52.7395 65.5 37C65.5 21.2605 52.7395 8.5 37 8.5Z",
    fill: "#20BE79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3605 49.504L21 39.1435L24.183 35.962L31.3605 43.1395L49.5 25L52.683 28.1815L31.3605 49.504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenFilledBordered);
export default __webpack_public_path__ + "static/media/check-green-filled-bordered.546c5ce7a2181de931c3427cd6495500.svg";
export { ForwardRef as ReactComponent };